
import { Spin } from "antd";

type LoadingFullScreenProps = {
  visible: boolean;
  message?: string;
};

export default function LoadingFullScreen({
  visible,
  message = "Loading...",
}: LoadingFullScreenProps) {
  if (!visible) return null;

  return (
    <Spin
      spinning={visible}
      fullscreen
      size="large"
      tip={message}
      style={{
        background: "rgba(0, 0, 0, 0.35)",
      }}
    />
  );
}
